// vim: set ts=2 sw=2 et ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY
 */


var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community/util': []
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Util = M.Community.View.Util || {};
  M.Community.View.Util.Common = M.Community.View.Util.Common || {};

  M.Community.View.Util.Common.scrollToSection = function(targetPosition) {
    $('html, body').animate({
      scrollTop: targetPosition
    }, 500, "easeInOutExpo");
  };

  M.Community.View.Util.DefaultFadingSpeed = 280;
  /**
   * For given params, will add a fadein/fadeout animation on hover.
   *
   * @param container - entering this container will trigger the hover
   * @param defaultContents - gets hidden on hover
   * @param hoverItem - gets shown on hover
   * @param fadingSpeed - speed of the hover animation
   */
  M.Community.View.Util.Common.addHoverToggleAnimation = function(
      container, defaultContents, hoverItem, fadingSpeed) {
    if (!fadingSpeed) {
      fadingSpeed = M.Community.View.Util.DefaultFadingSpeed;
    }

    // The fadeIn/stop/fadeOut sequences for the mouseover and mouseout states
    // are intentionally not the same, to prevent a jittery, unsmooth transition
    // from mouseover to mouseout
    container.hover(
      function() {
        hoverItem.fadeIn(fadingSpeed);
        defaultContents.stop();
        defaultContents.fadeOut(fadingSpeed);
      },
      function() {
        hoverItem.stop();
        hoverItem.fadeOut(fadingSpeed);
        defaultContents.fadeIn(fadingSpeed);
      }
    );
    };

  return {
  };

});
